import { DashboardDataGridField } from "~/feature/dashboard/components/DashboardDataGrid/types";

interface IDashboardViewColumn {
  key: string;
  label: string;
  field: DashboardDataGridField;
  defaultVisible: boolean;
}

export const DASHBOARD_VIEW_COLUMNS: readonly IDashboardViewColumn[] = [
  {
    key: "category",
    label: "Category",
    field: DashboardDataGridField.Category,
    defaultVisible: true,
  },
  {
    key: "spread",
    label: "Spread",
    field: DashboardDataGridField.Spread,
    defaultVisible: false,
  },
  {
    key: "volume",
    label: "Volume",
    field: DashboardDataGridField.Volume,
    defaultVisible: true,
  },
  {
    key: "liquidity",
    label: "Liquidity",
    field: DashboardDataGridField.Liquidity,
    defaultVisible: true,
  },
  {
    key: "vol24",
    label: "24h",
    field: DashboardDataGridField.H24,
    defaultVisible: false,
  },
  {
    key: "vol7d",
    label: "7d",
    field: DashboardDataGridField.D7,
    defaultVisible: false,
  },
  {
    key: "marketCount",
    label: "Markets",
    field: DashboardDataGridField.MarketCount,
    defaultVisible: false,
  },
  {
    key: "ends",
    label: "Ends in",
    field: DashboardDataGridField.EndsIn,
    defaultVisible: true,
  },
];

export const DEFAULT_HIDDEN_DASHBOARD_FIELDS: ReadonlySet<DashboardDataGridField> =
  new Set(
    DASHBOARD_VIEW_COLUMNS.filter((column) => !column.defaultVisible).map(
      (column) => column.field
    )
  );

export type DashboardDensity = "comfortable" | "compact";

interface IDensityOption {
  key: DashboardDensity;
  label: string;
  hint: string;
}

export const DENSITY_OPTIONS: readonly IDensityOption[] = [
  {
    key: "comfortable",
    label: "Comfortable",
    hint: "Taller rows with the TL;DR line under each title",
  },
  {
    key: "compact",
    label: "Compact",
    hint: "More rows per screen, TL;DR hidden",
  },
];

export const DEFAULT_DASHBOARD_DENSITY: DashboardDensity = "comfortable";

export const RELIABLE_PRICES_TOGGLE = {
  label: "Reliable prices only",
  hint: "Hide withheld prices. “Use with caution” stays visible.",
};

export const DEFAULT_RELIABLE_PRICES_ONLY = false;
